// Chart rendering decisions documented in docs/ai-insights-chart-rendering.md

/** Numeric axis ticks above this threshold are abbreviated (e.g. 44960 → 45K). */
export const COMPACT_NUMBER_THRESHOLD = 999;

/** Max category ticks on bar/column x-axes before thinning kicks in. */
export const MAX_CATEGORY_TICKS = 10;

/** Max category ticks on line chart x-axes (denser — every other label). */
export const MAX_LINE_CHART_TICKS = 15;

/** Labels longer than this trigger -45° tick rotation. */
export const ROTATION_LABEL_LENGTH = 4;

/** Bottom margin (px) when x-axis labels are horizontal. */
export const MARGIN_BOTTOM_NORMAL = 50;

/** Bottom margin (px) when x-axis labels are rotated -45°. */
export const MARGIN_BOTTOM_ROTATED = 70;

/** Legend offset (px) when x-axis labels are horizontal. */
export const LEGEND_OFFSET_BOTTOM_NORMAL = 36;

/** Legend offset (px) when x-axis labels are rotated -45°. */
export const LEGEND_OFFSET_BOTTOM_ROTATED = 56;

/** Max characters for horizontal bar chart category labels before truncation. */
export const BAR_CATEGORY_LABEL_MAX_CHARS = 16;

/** Left margin (px) for horizontal bar chart — wide enough for truncated category labels + axis legend. */
export const BAR_MARGIN_LEFT = 130;

/** Y-axis legend offset (px) for horizontal bar chart. */
export const BAR_LEGEND_OFFSET_LEFT = -120;

/** Bars narrower than this (px) hide their value label to avoid overlap. */
export const LABEL_SKIP_WIDTH = 28;

/** Left margin (px) reserved for funnel side labels. */
export const FUNNEL_SIDE_LABEL_WIDTH = 120;

/** Horizontal padding (px) on each side of the funnel bars. */
export const FUNNEL_PADDING_X = 32;

/** Max characters for funnel side labels before truncation. */
export const FUNNEL_SIDE_LABEL_MAX_CHARS = 18;
